import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ca-prop',
  templateUrl: './ca-prop.component.html',
  styleUrls: ['./ca-prop.component.scss']
})
export class CaPropComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
